module.exports = __webpack_public_path__ + "img/reason_img1.785f7b35.png";